import { Expose, plainToInstance, Transform, TransformFnParams } from "class-transformer";

export class Notification {}

export class RawNotification {
    notificationId: string;
    notificationType: string;
    isRead: string;
    categoryId: number;
    payload: Payload;
}

export class ModifiedNotification extends RawNotification {
    isSelected: boolean;
    category: NotificationsCategory;
}

export class Payload {
    accountId: string;
    notificationId: string;
    notificationType: string;
    createdDateTime: string;
    title: string;
    body: string;
    taskNumber: string;
    scrollTo: string | null;
    meetingId: string | null;
    meetingMode: string | null;
    meetingVenue: string | null;
    meetingDate: string | null;
    actualType?: string;
    teamId: number | null;
    entityTypeId: number | null; // used for conversation notifications
    entityId: number | null; // used for conversation notifications
    categoryId: number;
    stickyNoteId: string | null;
    orgId: number | null;
    punchRequestId: number | null;
}

export const NOTIFICATIONCONST = {
    NOTIFICATION_TYPE: "notificationType",
    EXTRA_NOTIFICATION_INTENT: "extraNotificationIntent",
    EXTRA_NOTIFICATION_ID: "extraNotificationID",
    NEW_NOTIFICATION_RECEIVER: "Notification_New_Notification",
    NEW_NOTIFICATION_ENTITY: "New_Notification_ENTITY",
    ScrollTo: {
        SCROLL_NOT_REQUIRED: 1,
        TASK_ESTIMATE: 2,
        TASK_EXP_START_DATETIME: 3,
        TASK_EXP_END_DATETIME: 4,
        TASK_CURRENT_ACTIVITY: 5,
        TASK_LIST_OF_DELIVERABLES_DELIVERED: 6,
        TASK_USER_PERCEIVED_PERCENTAGE: 7,
        TASK_CURRENTLY_SCHEDULED_TASK_INDICATOR: 8,
        TASK_ACT_START_DATETIME: 9,
        TASK_ACT_END_DATETIME: 10,
        TASK_WORKFLOW_STATUS: 11,
        TASK_RECORDED_EFFORT: 12,
        TASK_OBSERVER: 13,
        TASK_MENTOR: 14,
        TASK_PRIORITY: 15,
        TASK_ASSIGNED: 16,
        TASK_KEY_DECISIONS: 17,
        TASK_COMMENTS: 18,
        TASK_NOTES: 19,
        TASK_TITLE: 20,
        TASK_DESC: 21,
    },

    NotificationType: {
        CREATE_TASK: "CREATE_TASK",
        UPDATE_TASK: "UPDATE_TASK",
        UPDATE_TASK_IN_BACKLOG: "UPDATE_TASK_IN_BACKLOG",
        UPDATE_TASK_ESTIMATE: "UPDATE_TASK_ESTIMATE",
        UPDATE_TASK_TITLE: "UPDATE_TASK_TITLE",
        UPDATE_TASK_DESC: "UPDATE_TASK_DESC",
        UPDATE_TASK_SCHEDULE: "UPDATE_TASK_SCHEDULE",
        UPDATE_TASK_CURRENT_ACTIVITY: "UPDATE_TASK_CURRENT_ACTIVITY",
        UPDATE_TASK_PROGRESS: "UPDATE_TASK_PROGRESS",
        UPDATE_TASK_EFFORT: "UPDATE_TASK_EFFORT",
        UPDATE_TASK_STAKEHOLDERS: "UPDATE_TASK_STAKEHOLDERS",
        UPDATE_TASK_PRIORITY: "UPDATE_TASK_PRIORITY",
        UPDATE_TASK_ASSIGNMENT: "UPDATE_TASK_ASSIGNMENT",
        UPDATE_TASK_COMMUNICATION: "UPDATE_TASK_COMMUNICATION",
        UPDATE_TASK_OTHER_ACTIVITIES: "UPDATE_TASK_OTHER_ACTIVITIES",
        TASK_DELAYED: "TASK_DELAYED",
        TASK_WATCHLISTED: "TASK_WATCHLISTED",
        TASK_GETTING_DELAYED: "TASK_GETTING_DELAYED",
        TASK_GETTING_WATCHLISTED: "TASK_GETTING_WATCHLISTED",
        UPDATE_TASK_WORKFLOW_STATUS: "UPDATE_TASK_WORKFLOW_STATUS",
        UPDATE_TASK_MARK_COMPLETED: "UPDATE_TASK_MARK_COMPLETED",
        UPDATE_TASK_CURR_SCHEDULE_TASK_IND: "UPDATE_TASK_CURR_SCHEDULE_TASK_IND",
        UPDATE_TASK_CURR_ACTIVITY_IND: "UPDATE_TASK_CURR_ACTIVITY_IND",
        UPDATE_TASK_TIMESHEET: "UPDATE_TASK_TIMESHEET",
        UPDATE_TASK_ADD_COMMENT: "ADD_COMMENT",
        UPDATE_TASK_NOTES: "UPDATE_TASK_NOTES",
        UPDATE_TASK_KEY_DECISIONS: "UPDATE_TASK_KEY_DECISIONS",
        UPDATE_TASK_COMMENTS: "UPDATE_TASK_COMMENTS",
        IMMEDIATE_ATTENTION: "IMMEDIATE_ATTENTION",

        MEETING: "MEETING",
        MEETING_REMINDER: "MEETING_REMINDER",
        MEETING_INVITE: "MEETING_INVITE",
        MEETING_FOLLOW_UP: "MEETING_FOLLOW_UP",
        MEETING_UPDATE: "MEETING_UPDATE",
        START_MEETING_CONFIRMATION: "START_MEETING_CONFIRMATION",
        END_MEETING_CONFIRMATION: "END_MEETING_CONFIRMATION",
        MEETING_ANALYSIS: "MEETING_ANALYSIS",

        LEAVE_APPROVAL: "LEAVE_APPROVAL",
        LEAVE_APPLIED: "LEAVE_APPLIED",
        LEAVE_EXPIRED: "LEAVE_EXPIRED",
        LEAVE_REJECTED: "LEAVE_REJECTED",
        LEAVE_CANCELLED: "LEAVE_CANCELLED",
        LEAVE_UPDATED: "LEAVE_UPDATED",
        LEAVE_NOTIFICATION: "LEAVE_NOTIFICATION",

        IMPORT_JIRA:"IMPORT_JIRA",

        TIMESHEET_REMINDER: "TIMESHEET_REMINDER",
        UNKNOWN_NOTIFICATION_TYPE: "UNKNOWN_TYPE",

        VIEW_MEETING: "VIEW_MEETING",
        EDIT_MEETING: "EDIT_MEETING",
        MEETING_ORGANIZER_RESPONSE: "MEETING_ORGANIZER_RESPONSE",

        NEW_ACCESS_DOMAIN: "NEW_ACCESS_DOMAIN",
        UPDATED_ACCESS_DOMAIN: "UPDATED_ACCESS_DOMAIN",
        ACCESS_DOMAIN: "ACCESS_DOMAIN",
        GROUP_MESSAGE: "GROUP_MESSAGE",
        UPDATE_TASK_CURR_SCHEDULED_TASK_IND: "UPDATE_TASK_CURR_SCHEDULED_TASK_IND",
        UPDATE_TASK_RECORD_VOICE_STATUS: "UPDATE_TASK_RECORD_VOICE_STATUS",
        USER_PREFERENCE_UPDATE: "USER_PREFERENCE_UPDATE",
        USER_REMOVE_UPDATE: "USER_REMOVE_UPDATE",
        STATUS_INQUIRY: "STATUS_INQUIRY",
        MENTION_ALERTS_TC: "MENTION_ALERTS_TC",
        TASK_REMINDER: "TASK_REMINDER",
        EFFORT_ALERTS: "EFFORT_ALERTS",
        MENTION_ALERTS_GC: "MENTION_ALERTS_GC",
        USER_REMINDER: "USER_REMINDER",
        TEMPLATE_UPDATE: "TEMPLATE_UPDATE",
        UPDATED_USER_NAME: "UPDATED_USER_NAME",
        CHAT_MESSAGE_ALERTS: "CHAT_MESSAGE_ALERTS",
        STICKY_NOTES_NOTIFICATION: "STICKY_NOTES_NOTIFICATION",
        PUNCH_REQUEST: "PUNCH_REQUEST",
    },
};

export abstract class NotificationPayload {
    protected constructor(public notificationType: string) {}
}

export class CreateTaskNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.CREATE_TASK;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) teamId: number;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.CREATE_TASK);
    }
}

export class AccessDomainNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.ACCESS_DOMAIN;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) teamId: number;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.ACCESS_DOMAIN);
    }
}

export class UpdateTaskNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.UPDATE_TASK;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) teamId: number;

    @Expose()
    @Transform((value: TransformFnParams) => {
        const transformer = new ScrollToIntTransformer();
        return value.value === "null" ? NOTIFICATIONCONST.ScrollTo.SCROLL_NOT_REQUIRED : transformer.toClass(value);
    })
    scrollTo: number | null;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.UPDATE_TASK);
    }
}

export class ViewMeetingNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.VIEW_MEETING;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() meetingRoomName: string;
    @Expose() meetingDate: string;
    @Expose() meetingMode: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.VIEW_MEETING);
    }
}
export class JiraNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.IMPORT_JIRA;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.IMPORT_JIRA);
    }
}
export class ViewLeaveNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.LEAVE_NOTIFICATION;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.LEAVE_NOTIFICATION);
    }
}

export class EditMeetingNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string =
        NOTIFICATIONCONST.NotificationType.MEETING_ORGANIZER_RESPONSE;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() meetingRoomName: string;
    @Expose() meetingDate: string;
    @Expose() meetingMode: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.MEETING_ORGANIZER_RESPONSE);
    }
}

export class UserReminderNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.USER_REMINDER;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.USER_REMINDER);
    }
}

export class TemplateUpdateNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.TEMPLATE_UPDATE;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.TEMPLATE_UPDATE);
    }
}

export class GroupMessageNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.GROUP_MESSAGE;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() meetingRoomName: string;
    @Expose() meetingDate: string;
    @Expose() meetingMode: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.GROUP_MESSAGE);
    }
}

export class TimeSheetReminderNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.TIMESHEET_REMINDER;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.TIMESHEET_REMINDER);
    }
}

export class UserNameChangeNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.UPDATED_USER_NAME;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.UPDATED_USER_NAME);
    }
}

export class ChatMessageAlertsNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string = NOTIFICATIONCONST.NotificationType.CHAT_MESSAGE_ALERTS;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.CHAT_MESSAGE_ALERTS);
    }
}

export class StickyNoteNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string =
        NOTIFICATIONCONST.NotificationType.STICKY_NOTES_NOTIFICATION;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId:
        number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() stickyNoteId: string | null;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.STICKY_NOTES_NOTIFICATION);
    }
}

export class PunchInRequestNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string =
        NOTIFICATIONCONST.NotificationType.PUNCH_REQUEST;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) orgId: number;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) punchRequestId: number;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.PUNCH_REQUEST);
    }
}

export class UnknownNotification extends NotificationPayload {
    @Expose() title: string;
    @Expose() body: string;
    @Expose({ name: "notificationType" }) actualType: string =
        NOTIFICATIONCONST.NotificationType.UNKNOWN_NOTIFICATION_TYPE;
    @Expose() @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value)) accountId: number;
    @Expose()
    @Transform((value: TransformFnParams) => new ScrollToIntTransformer().toClass(value))
    notificationId: number;
    @Expose() createdDateTime: string;

    constructor() {
        super(NOTIFICATIONCONST.NotificationType.UNKNOWN_NOTIFICATION_TYPE);
    }
}

export class ScrollToIntTransformer {
    toClass(value: TransformFnParams): number | null {
        const stringValue = value.value as string;
        return stringValue && stringValue !== "null" ? parseInt(stringValue) : null;
    }

    toPlain(value: number | null): string | null {
        return value !== null ? value.toString() : null;
    }
}

export function objectify(payload: string) {
    const json = JSON.parse(payload);
    const notificationType = json.notificationType;
    switch (notificationType) {
        case NOTIFICATIONCONST.NotificationType.CREATE_TASK:
            return plainToInstance(CreateTaskNotification, json);
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_IN_BACKLOG:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_ESTIMATE:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_SCHEDULE:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_CURRENT_ACTIVITY:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_PROGRESS:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_EFFORT:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_STAKEHOLDERS:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_PRIORITY:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_ASSIGNMENT:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_COMMUNICATION:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_OTHER_ACTIVITIES:
        case NOTIFICATIONCONST.NotificationType.TASK_DELAYED:
        case NOTIFICATIONCONST.NotificationType.TASK_WATCHLISTED:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_WORKFLOW_STATUS:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_MARK_COMPLETED:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_CURR_SCHEDULE_TASK_IND:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_CURR_ACTIVITY_IND:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_TIMESHEET:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_ADD_COMMENT:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_NOTES:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_KEY_DECISIONS:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_COMMENTS:
        case NOTIFICATIONCONST.NotificationType.TASK_GETTING_DELAYED:
        case NOTIFICATIONCONST.NotificationType.TASK_GETTING_WATCHLISTED:
        case NOTIFICATIONCONST.NotificationType.IMMEDIATE_ATTENTION:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_TITLE:
        case NOTIFICATIONCONST.NotificationType.UPDATE_TASK_DESC:
        case NOTIFICATIONCONST.NotificationType.STATUS_INQUIRY:
        case NOTIFICATIONCONST.NotificationType.MENTION_ALERTS_TC:
        case NOTIFICATIONCONST.NotificationType.TASK_REMINDER:
        case NOTIFICATIONCONST.NotificationType.EFFORT_ALERTS:
            return plainToInstance(UpdateTaskNotification, json);
        case NOTIFICATIONCONST.NotificationType.LEAVE_NOTIFICATION:
        case NOTIFICATIONCONST.NotificationType.LEAVE_EXPIRED:
        case NOTIFICATIONCONST.NotificationType.LEAVE_APPROVAL:
        case NOTIFICATIONCONST.NotificationType.LEAVE_APPLIED:
        case NOTIFICATIONCONST.NotificationType.LEAVE_UPDATED:
        case NOTIFICATIONCONST.NotificationType.LEAVE_CANCELLED:
        case NOTIFICATIONCONST.NotificationType.LEAVE_REJECTED:
            return plainToInstance(ViewLeaveNotification, json);
        case NOTIFICATIONCONST.NotificationType.MEETING:
        case NOTIFICATIONCONST.NotificationType.MEETING_REMINDER:
        case NOTIFICATIONCONST.NotificationType.MEETING_INVITE:
        case NOTIFICATIONCONST.NotificationType.MEETING_FOLLOW_UP:
        case NOTIFICATIONCONST.NotificationType.MEETING_UPDATE:
            return plainToInstance(ViewMeetingNotification, json);
        case NOTIFICATIONCONST.NotificationType.START_MEETING_CONFIRMATION:
        case NOTIFICATIONCONST.NotificationType.END_MEETING_CONFIRMATION:
            console.log(plainToInstance(EditMeetingNotification, json));
            return plainToInstance(EditMeetingNotification, json);
        case NOTIFICATIONCONST.NotificationType.TIMESHEET_REMINDER:
            return plainToInstance(TimeSheetReminderNotification, json);
        case NOTIFICATIONCONST.NotificationType.NEW_ACCESS_DOMAIN:
        case NOTIFICATIONCONST.NotificationType.UPDATED_ACCESS_DOMAIN:
            return plainToInstance(AccessDomainNotification, json);
        case NOTIFICATIONCONST.NotificationType.GROUP_MESSAGE:
        case NOTIFICATIONCONST.NotificationType.MENTION_ALERTS_GC:
            return plainToInstance(GroupMessageNotification, json);
        case NOTIFICATIONCONST.NotificationType.USER_REMINDER:
            return plainToInstance(UserReminderNotification, json);
        case NOTIFICATIONCONST.NotificationType.TEMPLATE_UPDATE:
            return plainToInstance(TemplateUpdateNotification, json);
        case NOTIFICATIONCONST.NotificationType.UPDATED_USER_NAME:
            return plainToInstance(UserNameChangeNotification, json);
        case NOTIFICATIONCONST.NotificationType.CHAT_MESSAGE_ALERTS:
            return plainToInstance(ChatMessageAlertsNotification, json);
        case NOTIFICATIONCONST.NotificationType.IMPORT_JIRA:
            console.log(plainToInstance(JiraNotification, json))
            return plainToInstance(JiraNotification, json);
        case NOTIFICATIONCONST.NotificationType.STICKY_NOTES_NOTIFICATION:
            return plainToInstance(StickyNoteNotification, json);
        case NOTIFICATIONCONST.NotificationType.PUNCH_REQUEST:
            return plainToInstance(PunchInRequestNotification, json);
        default:
            return plainToInstance(UnknownNotification, json);
    }
}

export class NotificationActionsModel {
    notificationIdList: number[];
    accountIds: number[];
}

export class NotificationConstants {
    static readonly NOTIFICATIONS_DELETED = "Selected Notifications are deleted Successfully";
    static readonly NOTIFICATIONS_MARKED_AS_READ = "All Notifications Successfully Marked As Read";
    static readonly FIXED_NOTIFICATIONS_VALUE = 99;
}

export class CategoryWiserList {
    constructor(
        public categoryName: string,
        public totalNotifications: number,
        public unreadNotifications: number,
        public isSelected?: boolean,
    ) {}
}

export const NotificationSectionToShow = {
    CATEGORY_WISE: "CATEGORY_WISE",
    SORTED_BY_TIME: "SORTED_BY_TIME",
};

export class NotificationsCategory {
    categoryDesc: string | null;
    categoryId: number;
    categoryName: string;
    categoryType: string;
    createdDateTime: string;
    priority: number;

    constructor(init?: Partial<NotificationsCategory>) {
        Object.assign(this, init);
    }
}

export const UnCategorizedNotification = {
    categoryDesc: null,
    categoryId: 12,
    categoryName: "Uncategorized",
    categoryType: "User",
    createdDateTime: "",
    priority: 100,
};
